import { Field } from 'redux-form';

import {
  TextField,
  SelectField,
  CheckBox,
  RadioButton,
  DatePicker,
  TextArea,
  normalizeDecimal,
  normalizeInteger,
  normalizeDate
} from 'common/components/forms';

const FormQuestions = (props) => {
  const { c7Form } = props;
  if (!c7Form.questions) {
    return null;
  }
  if (c7Form.questions.length === 0) {
    return null;
  }
  return (
    <>
      {c7Form.questions.map((question) => (
        <div key={question.id}>{renderField(question)}</div>
      ))}
    </>
  );
};

const renderField = (question) => {
  switch (question.dataType) {
    case 'Number': {
      return (
        <Field
          name={`question-${question.id}`}
          component={TextField}
          label={question.title}
          normalize={normalizeDecimal}
          required={question.isRequired}
        />
      );
    }
    case 'Integer': {
      return (
        <Field
          name={`question-${question.id}`}
          component={TextField}
          label={question.title}
          normalize={normalizeInteger}
          required={question.isRequired}
        />
      );
    }
    case 'String': {
      return (
        <Field
          name={`question-${question.id}`}
          component={TextField}
          label={question.title}
          required={question.isRequired}
        />
      );
    }
    case 'Checkbox': {
      return (
        <>
          {question.title}
          {question.options.map((option) => (
            <Field
              name={`question-${question.id}-${option}`}
              component={CheckBox}
              type="checkbox"
              value={option}
              label={option}
              key={option}
              required={question.isRequired}
            />
          ))}
        </>
      );
    }
    case 'Radio': {
      return (
        <>
          {question.title}
          {question.options.map((option) => (
            <Field
              name={`question-${question.id}`}
              component={RadioButton}
              type="radio"
              value={option}
              label={option}
              key={option}
              required={question.isRequired}
            />
          ))}
        </>
      );
    }
    case 'Select': {
      return (
        <Field
          name={`question-${question.id}`}
          component={SelectField}
          label={question.title}
          optionArray={dropDownArray(question.options)}
          required={question.isRequired}
        />
      );
    }
    case 'Date Picker': {
      return (
        <Field
          name={`question-${question.id}`}
          component={DatePicker}
          label={question.title}
          normalize={normalizeDate}
          required={question.isRequired}
        />
      );
    }
    case 'TextArea': {
      return (
        <Field
          name={`question-${question.id}`}
          component={TextArea}
          label={question.title}
          rows={3}
          required={question.isRequired}
        />
      );
    }
    case 'True / False': {
      return (
        <>
          {question.title}
          <Field
            name={`question-${question.id}`}
            component={RadioButton}
            type="radio"
            value="True"
            label="True"
            required={question.isRequired}
          />
          <Field
            name={`question-${question.id}`}
            component={RadioButton}
            type="radio"
            value="False"
            label="False"
            required={question.isRequired}
          />
        </>
      );
    }
    case 'Yes / No': {
      return (
        <>
          {question.title}
          <Field
            name={`question-${question.id}`}
            component={RadioButton}
            type="radio"
            value="Yes"
            label="Yes"
            required={question.isRequired}
          />
          <Field
            name={`question-${question.id}`}
            component={RadioButton}
            type="radio"
            value="No"
            label="No"
            required={question.isRequired}
          />
        </>
      );
    }
    default: {
      return <div>{question.dataType}</div>;
    }
  }
};

const dropDownArray = (options) => {
  const optionArray = options.map((option) => ({
    value: option,
    option
  }));
  optionArray.unshift({ value: '', option: '' });
  return optionArray;
};

export default FormQuestions;
